import ValidateField from '../../hooks/useValid';
import { ValidateMessages } from '../../constants/ValidateConstants';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values, companydata, showImage) {
  const errors = {};
  let companycheck;
  if (!values?.id)
    companycheck = companydata?.find((obj) => obj?.countryId == values?.countryId && obj?.companyName == values.companyName);
  else
    companycheck = companydata?.find((obj) => obj?.countryId == values?.countryId && obj?.companyName == values.companyName && obj?.id !== values.id);

  errors.companyCode = ValidateField(
    values.companyCode,
    ValidateName?.COMPANY_CODE,
    ValidateName?.COMPANY_CODE,
    [ValidateName?.REQUIRED, ValidateName?.SHOULD_MAX_LETTER],
  );

  errors.companyName = ValidateField(
    values.companyName,
    ValidateName?.COMPANY_NAME,
    ValidateName?.COMPANY_NAME,
    [ValidateName?.REQUIRED, ValidateName?.MIN_LENGTH],
  );

  errors.email = ValidateField(
    values.email,
    ValidateName?.EMAIL,
    ValidateName?.EMAIL,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL],
  );

  errors.country = ValidateField(
    values.countryId,
    ValidateName?.COUNTRY,
    ValidateName?.COUNTRY,
    [ValidateName?.REQUIRED],
  );
  if (values.website !== "") {
    errors.website = ValidateField(
      values.website,
      ValidateName?.WEBSITE,
      ValidateName?.WEBSITE,
      [ValidateName?.ISVALID_URL],
    );
  }

  errors.phone = ValidateField(
    values.phone,
    ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
  );

  errors.address = ValidateField(
    values.address,
    ValidateName?.ADDRESS,
    ValidateName?.ADDRESS,
    [ValidateName?.REQUIRED],
  );

  errors.authorizedPerson = ValidateField(
    values.authorizedPerson,
    ValidateName?.AUTHORIZED_PERSON,
    ValidateName?.AUTHORIZED_PERSON,
    [ValidateName?.REQUIRED],
  );

  errors.designation = ValidateField(
    values.designationId,
    ValidateName?.POSITION,
    ValidateName?.POSITION,
    [ValidateName?.REQUIRED],
  );

  errors.logoUrl = ValidateField(
    values.logoUrl,
    ValidateName?.LOGO,
    ValidateName?.LOGO,
    [ValidateName?.REQUIRED]
  );

  errors.headerUrl = ValidateField(
    values.headerUrl,
    ValidateName?.HEADER,
    ValidateName?.HEADER,
    [ValidateName?.REQUIRED],
  );

  errors.footerUrl = ValidateField(
    values.footerUrl,
    ValidateName?.FOOTER,
    ValidateName?.FOOTER,
    [ValidateName?.REQUIRED],
  );

  if (companycheck) {
    errors.companyerr = ValidateMessages?.SHOULD_SAME_FIELD_NAME("company");
  }

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })

  return error;
}


export function validationContact(values, contact) {
  const errors = {};

  errors.name = ValidateField(
    values.name,
    ValidateName?.CONTACT_NAME,
    ValidateName?.CONTACT_NAME,
    [ValidateName?.REQUIRED, ValidateName?.ISTEXTONLY],
  );

  errors.phone = ValidateField(
    values.phone,
    ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
  );

  errors.email = ValidateField(
    values.email,
    ValidateName?.EMAIL,
    ValidateName?.EMAIL,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL],
  );

  errors.department = ValidateField(
    values.departmentId,
    ValidateName?.DEPARTMENT,
    ValidateName?.DEPARTMENT,
    [ValidateName?.REQUIRED],
  );
  errors.designation = ValidateField(
    values.designationId,
    ValidateName?.DESINATION,
    ValidateName?.DESINATION,
    [ValidateName?.REQUIRED],
  );

  errors.contact = ValidateField(
    values,
    ValidateName?.CONTACT_AVAILABLE,
    ValidateName?.CONTACT_AVAILABLE,
    [ValidateName?.UNIQUE_CONTACTS], undefined, contact
  );

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })

  return error
}
